<template>
  <div class="rightChart">
    <div class="twoGraphBox">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">政府采购中标项目数量省级分布</div>
        </div>
        <!-- 地图 -->
        <div id="map" class="newgraph_box"></div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">中标项目按项目实施地分TOP10</div>
        </div>
        <!-- 柱图 -->
        <div id="graph" class="newgraph_box"></div>
      </div>
    </div>

    <div class="twoGraphBox">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">政府采购中标项目数量按品目分</div>
        </div>
        <!-- 饼图 -->
        <div id="graph2" class="newgraph_box"></div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">货物二级品目中标项目数量Top5</div>
        </div>
        <!-- 横向柱图 -->
        <div id="thin1" class="newgraph_box"></div>
      </div>
    </div>

    <div class="twoGraphBox">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">按公告类型分中标项目个数</div>
        </div>
        <!-- 饼图 -->
        <div id="graph3" class="newgraph_box"></div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">PPP项目统计情况</div>
        </div>
        <!-- 纵向柱图 -->
        <!-- <div id="graph4" class="newgraph_box"></div> -->
        <div style="height: 100%; width: 60%; margin: 0px auto; position: relative;">
          <span
            v-if="pppData.length"
            style="display: block; position: absolute; top: 90px; left: 7%; width: 156px; height: 156px; background: radial-gradient(circle, rgba(3, 35, 72, 0.8), rgb(3, 96, 185)); border-radius: 50%;"
          >
            <i
              style="display: block; width: 86%; height: 50%; text-align: center; color: rgb(255, 255, 255); line-height: 10; font-style: normal; margin: 0px auto; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
            >{{pppData[0].value}}个</i>
            <i
              style="display: block; width: 86%; height: 50%; text-align: center; color: rgb(255, 255, 255); font-style: normal; margin: 4px auto 0px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
            >{{pppData[0].name}}</i>
          </span>
          <span
            v-if="pppData.length"
            style="display: block; position: absolute; top: 194px; left: 68%; width: 156px; height: 156px; background: radial-gradient(circle, rgba(3, 35, 72, 0.8), rgb(0, 147, 160)); border-radius: 50%;"
          >
            <i
              style="display: block; width: 86%; height: 50%; text-align: center; color: rgb(255, 255, 255); line-height: 10; font-style: normal; margin: 0px auto; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
            >{{pppData[1].value}}亿元</i>
            <i
              style="display: block; width: 86%; height: 50%; text-align: center; color: rgb(255, 255, 255); font-style: normal; margin: 4px auto 0px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
            >{{pppData[1].name}}</i>
          </span>
        </div>
      </div>
    </div>

    <!-- 时间线 -->
    <div class="bottom_timeLine">
      <div id="timeLine"></div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import echarts from "echarts";
import chinaJson from "../../static/common/china.json";
export default {
  data() {
    return {
      xAxis_data: [],
      moveYearsList: [], //时间轴数据
      series_data: [],
      timeLine: null,
      pppData: []
    };
  },
  props: ["initEchart"],
  watch: {
    initEchart() {
      this.init();
      this.timeLine.resize();
    }
  },
  methods: {
    //图一-中国地图
    map(year) {
      var mapList = [];
      var myMap = echarts.init(document.getElementById("map"));
      myMap.resize();
      api.getOrderOrRegionMap({ type: "1", year: year }).then(res => {
        res.data.forEach(item => {
          var newArr = {};
          newArr.name = item.name
            .replace("省", "")
            .replace("市", "")
            .replace("自治区", "");
          newArr.value = item.value;
          mapList.push(newArr);
        });
        echarts.registerMap("china", chinaJson);
        myMap.setOption(optionMap);
      });
      var optionMap = {
        tooltip: {
          //鼠标移上去时显示悬浮框
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "{b}\n{c}个"
        },
        visualMap: {
          //图注
          min: 0,
          max: 3000,
          left: "left",
          top: "bottom",
          text: ["高", "低"],
          inRange: {
            color: ["#87cefa", "#dfed27", "#e6521b"]
          },
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: 400
          },
          show: true
        },

        series: [
          //整体配置
          {
            name: "中国",
            type: "map",
            mapType: "china",
            // roam: true,//缩放
            zoom: 1.2,
            label: {
              normal: {
                show: true //省份名称
              }
            },
            data: mapList
          }
        ]
      };
    },
    //图二-柱状图
    graph(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph = echarts.init(document.getElementById("graph"));
      myGraph.resize();
      api.getOrderOrRegionMap({ type: "2", year: year }).then(res => {
        let _data = res.data;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push(v.value);
        });

        var option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: "{b}\n{c}个"
          },
          grid: {
            top: "10%",
            right: "1%",
            left: "10%",
            bottom: "15%"
          },
          xAxis: [
            {
              type: "category",
              data: xAxis_data, //['湖北', '福建', '山东', '广西', '浙江', '河南', '河北']
              axisLine: {
                lineStyle: {
                  color: "rgba(255,255,255,0.12)"
                }
              },
              axisLabel: {
                margin: 10,
                color: "#e2e9ff",
                textStyle: {
                  fontSize: 12
                }
              }
            }
          ],
          yAxis: [
            {
              splitNumber: 3,
              axisLabel: {
                formatter: "{value}k",
                color: "#e2e9ff"
              },
              axisLine: {
                show: true
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: "#233e64"
                }
              }
            }
          ],
          series: [
            {
              type: "bar",
              data: series_data, //[300, 450, 770, 203, 255, 188, 156]
              barWidth: "10px",
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(0,244,255,1)" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(0,77,167,1)" // 100% 处的颜色
                      }
                    ],
                    false
                  ),
                  barBorderRadius: [30, 30, 30, 30],
                  shadowColor: "rgba(0,160,221,1)",
                  shadowBlur: 4
                }
              }
            }
          ]
        };

        myGraph.setOption(option);
      });
    },
    //图三-饼图
    graph2(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph2 = echarts.init(document.getElementById("graph2"));
      myGraph2.resize();
      api.getOrderOrRegionMap({ type: "3", year: year }).then(res => {
        let _data = res.data;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push({ name: v.name, value: v.value });
        });

        var option = {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}个"
          },
          legend: {
            orient: "vertical",
            //图例
            right: 40,
            top: 20,
            data: xAxis_data,
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontWeight: 400
            }
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["32%", "45%"], //半径
              avoidLabelOverlap: false,
              color: [
                "#177fe8",
                "#ef7041",
                "#a8d9ab",
                "#03aab9",
                "#88cff8",
                "#ded668",
                "#c0e272"
              ],
              label: {
                show: false,
                position: "center",
                normal: {
                  //指示线指示文字
                  show: true,
                  position: "outside",
                  formatter: "{d}%",
                  textStyle: {
                    fontWeight: 400,
                    fontSize: 12,
                    color: "#fff"
                  }
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "12",
                  fontWeight: "bold"
                }
              },
              labelLine: {
                show: false,
                normal: {
                  //指示线指示文字
                  show: true,
                  length: 40,
                  length2: 27,
                  lineStyle: {
                    width: 1
                  }
                }
              },
              // itemStyle: {
              //     borderWidth: 1,
              //     borderColor: "#fff"
              // },
              data: series_data
              // data: [
              //   { value: , name: "" },
              // ]
            }
          ]
        };
        myGraph2.setOption(option);
      });
    },
    //图四-横向柱状图
    thin1(year) {
      var thin1 = echarts.init(document.getElementById("thin1"));
      thin1.resize();
      api.getOrderOrRegionMap({ type: "4", year: year }).then(res => {
        let _data = res.data;
        _data.sort((a, b) => {
          return a.value - b.value;
        });
        option.series[0].data = _data;
        let tmpData = [];
        if (_data.length > 0) {
          for (let i = 0; i < _data.length; i++) {
            tmpData.push(_data[i].name);
          }
          option.yAxis[0].data = tmpData;
        }
        if (option && typeof option === "object") {
          thin1.setOption(option);
          window.onresize = thin1.resize;
        }
      });
      let option = {
        color: ["#1C83E8"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{b} {c}个"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        yAxis: [
          {
            axisLine: { show: false }, //去掉线
            axisTick: { show: false }, //去掉点
            type: "category",
            data: [],
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        xAxis: [
          {
            type: "value",
            show: false
          }
        ],
        series: [
          {
            name: "上市公司数量",
            type: "bar",
            barWidth: "30%",
            radius: "2px",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#DFECF7",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
    },
    //图五-饼图
    graph3(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph2 = echarts.init(document.getElementById("graph3"));
      myGraph2.resize();
      api.getOrderOrRegionMap({ type: "5", year: year }).then(res => {
        let _data = res.data;
        _data.forEach((v, i) => {
          let tmp = "";
          v.name == "dfgg" ? (tmp = "地方公告") : "";
          v.name == "zygg" ? (tmp = "中央公告") : "";

          xAxis_data.push(tmp);
          series_data.push({ name: tmp, value: v.value });
        });

        var option = {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}个"
          },
          legend: {
            orient: "vertical",
            //图例
            right: 40,
            top: 20,
            data: xAxis_data,
            // data: ['地方公告','中央公告'],
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontWeight: 400
            }
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["32%", "45%"], //半径
              avoidLabelOverlap: false,
              color: [
                "#177fe8",
                "#ef7041",
                "#a8d9ab",
                "#03aab9",
                "#88cff8",
                "#ded668",
                "#c0e272"
              ],
              label: {
                show: false,
                position: "center",
                normal: {
                  //指示线指示文字
                  show: true,
                  position: "outside",
                  formatter: "{d}%",
                  textStyle: {
                    fontWeight: 400,
                    fontSize: 12,
                    color: "#fff"
                  }
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "12",
                  fontWeight: "bold"
                }
              },
              labelLine: {
                show: false,
                normal: {
                  //指示线指示文字
                  show: true,
                  length: 40,
                  length2: 27,
                  lineStyle: {
                    width: 1
                  }
                }
              },
              // itemStyle: {
              //     borderWidth: 1,
              //     borderColor: "#fff"
              // },
              data: series_data
              // data: [
              //   { value: , name: "" },
              // ]
            }
          ]
        };
        myGraph2.setOption(option);
      });
    },
    //图六-纵向柱状图
    graph4(year) {
      let _this = this;
      // var xAxis_data = [];
      // var series_data = [];
      // var myGraph2 = echarts.init(document.getElementById("graph4"));
      // myGraph2.resize();
      api.getOrderOrRegionMap({ type: "6", year: year }).then(res => {
        let _data = res.data[0].data;
        _this.pppData = _data;
        console.log(_data, "_data");
        // _data.forEach((v, i) => {
        //   xAxis_data.push(v.name);
        //   series_data.push(Number(v.value));
        //   v.value = Number(v.value);
        // });
        // console.log(_data,'_data')
        // var option = {
        //   color: ["#1C83E8"],
        //   // tooltip: {
        //   //   trigger: "axis",
        //   //   axisPointer: {
        //   //     // 坐标轴指示器，坐标轴触发有效
        //   //     type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        //   //   },
        //   //   formatter: "中标项目总金额: {c}亿元"
        //   // },
        //   tooltip: {
        //     formatter: (params, ticket, callback) => {

        //       if(params.name == 'PPP项目数'){
        //         return `PPP项目数：${params.value}个`;
        //       }
        //       if(params.name == '项目总金额'){
        //         return `中标项目总金额 ${params.value}亿元`;
        //       }

        //       return ''
        //     }
        //   },

        //   grid: {
        //     left: "3%",
        //     right: "4%",
        //     bottom: "4%",
        //     containLabel: true
        //   },
        //   xAxis: [
        //     {
        //       type: "category",
        //       data: xAxis_data,
        //       axisTick: {
        //         alignWithLabel: true
        //       },
        //       axisLabel: {
        //         interval: 0,
        //         textStyle: {
        //           color: "#fff"
        //         }
        //       }
        //     }
        //   ],
        //   yAxis: [
        //     {
        //         nameTextStyle: {
        //             color: '#5A5A5A',
        //         },
        //         type: "value",
        //         // position: "right",
        //         axisLine: {
        //             lineStyle: {
        //                 color: "#E0E0E0"
        //             }
        //         },
        //         axisTick: {
        //             show: false,
        //         },
        //         min: 0,
        //         max: (res.data[0].Y1[res.data[0].Y1.length-1] > res.data[0].Y2[res.data[0].Y2.length-1]) ? res.data[0].Y1[res.data[0].Y1.length-1] : res.data[0].Y2[res.data[0].Y2.length-1],
        //         axisLabel: {
        //             textStyle: {
        //               color: "#fff",
        //             },
        //             show: true,
        //             interval: "auto",
        //             formatter: "{value}个",
        //         },
        //         show: true,
        //         splitLine: {  //网格线
        //             show: false
        //         }
        //     },
        //     {
        //       type: "value",
        //       axisLabel: {
        //           textStyle: {
        //             color: "#fff",
        //           },
        //           show: true,
        //           interval: "auto",
        //           formatter: "{value}亿元",
        //       },
        //       axisLine: {
        //         lineStyle: {
        //           color: "#E0E0E0"
        //         }
        //       },
        //       axisTick: {
        //         show: false,
        //       },
        //       min: 0,
        //       max: (res.data[0].Y1[res.data[0].Y1.length-1] > res.data[0].Y2[res.data[0].Y2.length-1]) ? res.data[0].Y1[res.data[0].Y1.length-1] : res.data[0].Y2[res.data[0].Y2.length-1],
        //     }
        //   ],
        //   series: [
        //     {
        //       type: "bar",
        //       barWidth: "60%",
        //       data: series_data
        //     }
        //   ]
        // };
        // myGraph2.setOption(option);
      });
    },
    time() {
      this.timeLine = echarts.init(document.getElementById("timeLine"));
      let option = {
        timeline: {
          data: this.moveYearsList,
          axisType: "category",
          autoPlay: false,
          playInterval: 3000,
          left: "0",
          right: "0",
          bottom: "5%",
          width: "100%",
          //  height: null,
          label: {
            normal: {
              textStyle: {
                color: "#ddd"
              }
            },
            emphasis: {
              textStyle: {
                color: "#fff"
              }
            }
          },
          symbolSize: 10,
          lineStyle: {
            color: "#555"
          },
          checkpointStyle: {
            borderColor: "#777",
            borderWidth: 2
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: "#666",
              borderColor: "#666"
            },
            emphasis: {
              color: "#aaa",
              borderColor: "#aaa"
            }
          }
        }
      };
      this.timeLine.setOption(option);
      this.timeLine.resize();
      this.timeLine.on("timelinechanged", v => {
        let time = this.moveYearsList[v.currentIndex];
        this.map(time); //地图
        this.thin1(time); //折线图1
        this.graph(time); //柱图
        this.graph2(time); //柱图
        this.graph3(time); //图五-饼图
        this.graph4(time); //图六-纵向柱状图
      });
    },
    init() {
      api.getCpanTimes().then(res => {
        let year = res.data[0].slice(0, 4);
        this.moveYearsList = res.data;
        this.time();
        this.map(year); //图一-中国地图
        this.thin1(year); //图四-横向柱状图
        this.graph(year); //图二-柱状图
        this.graph2(year); //图三-饼图
        this.graph3(year); //图五-饼图
        this.graph4(year); //图六-纵向柱状图
      });
    }
  },
  beforeDestroy() {
    if (!this.timeLine) {
      return;
    }
    this.timeLine.dispose();
    this.timeLine = null;
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped lang="less">
/* scrollbar */
.rightChart::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
.rightChart::-webkit-scrollbar-thumb {
  background: #3583ed;
  border-radius: 5px;
}
.rightChart::-webkit-scrollbar-track {
  background: #dfdfdf;
  border-radius: 5px;
}
/* 针对IE的scrollbar */
.rightChart {
  scrollbar-face-color: #3583ed; /*3D表面（ThreedFace）*/
  scrollbar-highlight-color: #dfdfdf; /*3D界面的亮边（ThreedHighlight）*/
  scrollbar-shadow-color: #dfdfdf; /*3D界面的暗边（ThreedShadow）*/
  scrollbar-3dlight-color: #dfdfdf; /*亮边框*/
  scrollbar-arrow-color: #3583ed; /*方向箭头 */
  scrollbar-track-color: #dfdfdf; /*拖动区域(TrackBar)*/
  scrollbar-darkshadow-color: #dfdfdf; /*暗边框（ThreedDarkShadow）*/
}
/* 针对firefox的scrollbar */
.rightChart {
  scrollbar-color: #3583ed #dfdfdf;
  scrollbar-width: thin;
}
/* Edge 的scrollbar隐藏*/
/* .rightChart{
    -ms-overflow-style:none;
} */
// 可视化
.rightChart {
  width: auto;
  height: auto;
  margin-right: 20px;
  padding: 20px 20px 50px 20px;
  background: rgba(5, 43, 79, 0.3);
  border: 1px solid #08396a;
  display: flex;
  flex-wrap: wrap;
  // overflow-x: scroll;
  .twoGraphBox {
    width: 100%;
    overflow: hidden;
    margin-bottom: 15px;
    .lefBox {
      width: 49%;
      height: 550px;
      float: left;
      .newTitle {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #08396a;
        overflow: hidden;
        .newlittleImg {
          float: left;
          img {
            width: 12px;
            height: 12px;
          }
        }
        .newword {
          margin-left: 4px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #dfecf7;
          float: left;
        }
      }
      .newgraph_box {
        width: 100%;
        height: 530px;
        margin: 0 auto;
        overflow: hidden;
      }
    }
    .ritBox {
      width: 49%;
      height: 550px;
      float: right;
      .newTitle {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #08396a;
        overflow: hidden;
        .newlittleImg {
          float: left;
          img {
            width: 12px;
            height: 12px;
          }
        }
        .newword {
          margin-left: 4px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #dfecf7;
          float: left;
        }
      }
      .newgraph_box {
        width: 100%;
        height: 530px;
        margin: 0 auto;
        overflow: hidden;
      }
    }
  }

  .bottom_timeLine {
    width: 100%;
    height: 100px;
    margin-top: 20px;
    // display: flex;
    // align-items: center;
    // box-sizing: border-box;
    // img {
    //   height: 41px;
    //   width: 41px;
    // }
    // .img {
    //   width: 28px;
    //   height: 28px;
    //   margin: 0 10px;
    // }
    // .thinBox {
    //   width: 100%;
    //   display: flex;
    //   flex-direction: column;
    // }
    // .thins {
    //   width: 100%;
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   padding-top: 10px;
    //   cursor: pointer;
    //   p {
    //     font-size: 14px;
    //     font-family: Arial;
    //     font-weight: 400;
    //     color: #6d84a2;
    //   }
    // }
    // .thin {
    //   margin-top: 30px;
    //   width: 100%;
    //   height: 2px;
    //   background: rgba(48, 151, 254, 0.5);
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   cursor: pointer;
    //   p {
    //     width: 10px;
    //     height: 10px;
    //     background: #177de5;
    //     border-radius: 50%;
    //     cursor: pointer;
    //   }
    //   p:hover {
    //     background: #d5ebff;
    //   }
    // }
    #timeLine {
      width: 100%;
      height: 100px;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tenEchart.vue